import * as React from "react";
import TextAction, { TextActionProps } from "./TextAction";

export default function ViewAction(props: TextActionProps) {
  return <TextAction {...props} icon="ic_eye" label={props.label || i18n["Global.Show"]} />;
}
